import { theme } from 'antd';
import React from 'react';
import { Flex, Typography } from 'zui/Antd';

const { Text } = Typography;

const InfoTuple = ({ icon, text, value, highlight, error, errorContent, align = 'center' }) => {
	const {
		token: { paddingXS, fontSizeLG, colorText, colorTextLabel, fontWeightStrong, colorSuccessText }
	} = theme.useToken();

	const styledIcon = icon
		? React.cloneElement(icon, {
				style: {
					fontSize: fontSizeLG,
					color: colorTextLabel,
					...icon?.props?.style
				}
			})
		: null;

	return (
		<Flex vertical>
			<Flex flex={1} align={align} wrap justify='space-between' gap={paddingXS}>
				<Flex align='center' wrap gap={paddingXS}>
					{styledIcon}
					<Text
						style={{
							fontSize: fontSizeLG,
							color: colorTextLabel,
							fontWeight: fontWeightStrong,
							lineHeight: '24px'
						}}
					>
						{text}
					</Text>
				</Flex>
				<Text
					style={{
						fontSize: fontSizeLG,
						lineHeight: '24px',
						color: highlight ? (highlight === 'success' ? colorSuccessText : '#A0A0A0') : colorText
					}}
				>
					{value}
				</Text>
			</Flex>
			{error && errorContent}
		</Flex>
	);
};

export default InfoTuple;
